module.exports = __webpack_public_path__ + "img/developer.7db1aa3b.svg";